// extracted by mini-css-extract-plugin
module.exports = {"cart":"Cart_cart__w1ldf","cartDivider":"Cart_cartDivider__1bN1Q"};